import { requestContract } from "./coaching-services-transport";
import type { Requester } from "./coaching-services-transport";
import type {
  CoachingPlatformOrganization,
  CoachingPlatformOrganizationCreateRequest,
  CoachingPlatformOrganizationCreateResponse,
  CoachingPlatformOrganizationsListResponse
} from "@vjal/api-contract";

export function createPlatformOrganizationsService(requester: Requester) {
  return {
    list: async (): Promise<CoachingPlatformOrganization[]> => {
      const response = await requestContract<CoachingPlatformOrganizationsListResponse>(requester, "platformOrganizations.list");
      return response.organizations;
    },
    create: (body: CoachingPlatformOrganizationCreateRequest, idempotencyKey: string) =>
      requestContract<CoachingPlatformOrganizationCreateResponse>(requester, "platformOrganizations.create", {
        body,
        idempotencyKey
      })
  };
}
